"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureMinimumRuleSet = exports.updateRule = exports.removeRule = exports.addRule = exports.groupRules = exports.createEmptyRule = void 0;
const lodash_1 = require("lodash");
const createId = () => {
    return Math.floor(Math.random() * (Math.pow(2, 53) - 1));
};
exports.createEmptyRule = (groupId = createId()) => ({
    id: createId(),
    group: groupId,
    key: '',
    value: '',
    match: undefined,
});
const gatherAndGroups = (criteria) => lodash_1.groupBy(criteria, (rule) => rule.group);
const createLogicalAndGroup = (rules, group) => ({ group, rules });
exports.groupRules = (criteria) => {
    const rawAndGroups = gatherAndGroups(criteria);
    const groupIds = lodash_1.keys(rawAndGroups);
    return groupIds.map(key => createLogicalAndGroup(rawAndGroups[key], lodash_1.toNumber(key)));
};
exports.addRule = (criteria, rule) => [
    ...criteria,
    rule,
];
exports.removeRule = (criteria, ruleId) => {
    const updated = lodash_1.reject(criteria, (rule) => rule.id === ruleId);
    return lodash_1.isEmpty(updated) ? [exports.createEmptyRule()] : updated;
};
exports.updateRule = (criteria, rule) => lodash_1.map(criteria, (r) => (r.id === rule.id ? rule : r));
exports.ensureMinimumRuleSet = (criteria) => lodash_1.isEmpty(criteria) ? [exports.createEmptyRule()] : criteria;
